import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from 'src/app/api/profile.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-support-page',
  templateUrl: './support-page.component.html',
  styleUrls: ['./support-page.component.scss']
})
export class SupportPageComponent implements OnInit {
  type: string;

  vip = false;

  constructor(
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private localeService: LocaleService,
  ) {
    this.type = this.route.snapshot.paramMap.get('type');
  }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.profileService.getGeneral().subscribe(response => {
      this.vip = response.vip;
    });
  }

  get lang() {
    return this.localeService.currentLocale;
  }

}
